module.exports = __webpack_public_path__ + "img/myanmar.62c76563.svg";